import React from 'react';
import { ReactComponent as LoadingSpinnerSvg } from 'assets/loading.svg';

export const LoadingSpinner: React.FunctionComponent<any> = (props) => (
  <LoadingSpinnerSvg className="svgLoader" {...props} />
);
